import React from 'react';

var LandlinePhone = function LandlinePhone(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "Landline phone"), /*#__PURE__*/React.createElement("path", {
    d: "M11.89 19.084s-1.61-1.562-3.368-4.609c1.57 2.719 3.369 4.609 3.369 4.609 1.095 1.189 2.808 1.674 4.766.543l2.243-1.294a.952.952 0 0 0 .338-1.296l-1.373-2.38a.955.955 0 0 0-1.303-.346l-2.612 1.508s-.734-.406-2.304-3.125c-1.569-2.717-1.544-3.539-1.544-3.539l2.613-1.508a.956.956 0 0 0 .35-1.303L11.69 3.965A.952.952 0 0 0 10.4 3.61L8.157 4.905c-1.958 1.13-2.394 2.857-1.912 4.4 0 0 .707 2.452 2.277 5.17-1.76-3.046-2.277-5.17-2.277-5.17",
    stroke: "currentColor",
    strokeWidth: "2",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

LandlinePhone.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
import iconHandler from './hoc';
export { LandlinePhone as icon };
export default iconHandler(LandlinePhone);